import Shimmer from '@/components/ui/Shimmer';
import { memo } from 'react';

const ComponentLazyShimmer = memo(() => {
  return (
    <div className="container w-full py-5">
      <Shimmer className="h-10 w-1/3" />
      <Shimmer className="my-5 h-8 w-1/2" />
      <Shimmer className="h-48 w-full" />
    </div>
  );
});
export default ComponentLazyShimmer;
